export const transformBrToNHelper = (string: string) => {
  return string
    ? string
        //.replace(/[;]/g, '\n')
        .replace(/<BR>/g, "\n")
        .replace(/<br>/g, "\n")
        .replace(/(href=)/g, `target='_blank' href=`)
    : "";
};
